import { apiFetch } from '../httpClient';

const TEAM_MEMBERS_ENDPOINT_TEMPLATE =
  process.env.REACT_APP_TEAM_MEMBERS_ENDPOINT_TEMPLATE || '/api/teams/:teamId/members';
const TEAM_MEMBER_ROLE_UPDATE_ENDPOINT_TEMPLATE =
  process.env.REACT_APP_TEAM_MEMBER_ROLE_UPDATE_ENDPOINT_TEMPLATE || '/api/teams/:teamId/members/:userId/role';
const TEAM_MEMBER_REMOVE_ENDPOINT_TEMPLATE =
  process.env.REACT_APP_TEAM_MEMBER_REMOVE_ENDPOINT_TEMPLATE || '/api/teams/:teamId/members/:userId';
const TEAM_CHAIR_DELEGATE_ENDPOINT_TEMPLATE =
  process.env.REACT_APP_TEAM_CHAIR_DELEGATE_ENDPOINT_TEMPLATE || '/api/teams/:teamId/chair/delegate';
const TEAM_LEAVE_ENDPOINT_TEMPLATE =
  process.env.REACT_APP_TEAM_LEAVE_ENDPOINT_TEMPLATE || '/api/teams/:teamId/members/me';

function buildPathFromTemplate(template, pathParams = {}) {
  return Object.entries(pathParams).reduce((path, [key, value]) => {
    return path
      .replace(`:${key}`, encodeURIComponent(String(value)))
      .replace(`{${key}}`, encodeURIComponent(String(value)));
  }, template);
}

export async function fetchTeamMembers({ teamId }) {
  return apiFetch(buildPathFromTemplate(TEAM_MEMBERS_ENDPOINT_TEMPLATE, { teamId }), {
    method: 'GET',
  });
}

export async function updateTeamMemberRole({ teamId, userId, role }) {
  return apiFetch(
    buildPathFromTemplate(TEAM_MEMBER_ROLE_UPDATE_ENDPOINT_TEMPLATE, {
      teamId,
      userId,
    }),
    {
      method: 'PATCH',
      body: {
        role,
        memberRole: role,
      },
    },
  );
}

export async function removeTeamMember({ teamId, userId }) {
  return apiFetch(
    buildPathFromTemplate(TEAM_MEMBER_REMOVE_ENDPOINT_TEMPLATE, {
      teamId,
      userId,
    }),
    {
      method: 'DELETE',
    },
  );
}

export async function delegateTeamChair({ teamId, userId }) {
  return apiFetch(buildPathFromTemplate(TEAM_CHAIR_DELEGATE_ENDPOINT_TEMPLATE, { teamId }), {
    method: 'POST',
    body: {
      userId,
      targetUserId: userId,
      newChairUserId: userId,
    },
  });
}

export async function leaveTeam({ teamId }) {
  return apiFetch(buildPathFromTemplate(TEAM_LEAVE_ENDPOINT_TEMPLATE, { teamId }), {
    method: 'DELETE',
  });
}
